import React from "react";
import { ToastProvider } from "../Hooks/toast";
import { PageAlertProvider } from "../Hooks/usePageAlert";
import { ProgressAlertProvider } from "../Hooks/useProgressAlert";
import { BalanceProvider } from "../Hooks/useBalance";
import { SupportProvider } from "./SupportContext";

const ApplicationProvider: React.FC = ({ children }) => {
  return (
    <PageAlertProvider>
      <ToastProvider>
        <ProgressAlertProvider>
          <BalanceProvider>
            <SupportProvider>
              {children}
            </SupportProvider>
          </BalanceProvider>
        </ProgressAlertProvider>
      </ToastProvider>
    </PageAlertProvider>
  );
};

export default ApplicationProvider;
